const EVENT_NAME = {
    NO_LOGIN: 'no_login', // 未登录时点击
    NO_REMAIN: 'no_remain', // 无抽奖机会时点击
    DRAW_SUCCESS: 'draw_success', // 抽奖成功回调
    DRAW_FAIL: 'draw_fail', // 抽奖失败回调
    FAIL_MODAL_BTN_CLICK: 'fail_modal_btn_click' // 抽奖失败弹窗按钮点击回调
};

const REMAIN_COUNT_PLACEHOLDER = '{count}';

const SUCCESS_DRAW_COUNT_PLACEHOLDER = '{successCount}';
const FAIL_DRAW_COUNT_PLACEHOLDER = '{failCount}';

const ANIMATION_STEP = {
    START: 'start', // 开始动画
    LOOP: 'loop', // 循环动画
    END: 'end' // 结束动画
};

export {
    EVENT_NAME,
    REMAIN_COUNT_PLACEHOLDER,
    SUCCESS_DRAW_COUNT_PLACEHOLDER,
    FAIL_DRAW_COUNT_PLACEHOLDER,
    ANIMATION_STEP
};
